module.exports = __webpack_public_path__ + "img/eye.37776ca8.jpg";